import React from 'react';
import PropTypes from 'prop-types';
import { IconButton } from '@mui/material';
import Iconify from '@/components/Iconify';

const getIconVariant = (variant) => {
  switch (variant) {
    case 'left':
      return 'material-symbols:keyboard-arrow-left';
    case 'right':
      return 'material-symbols:keyboard-arrow-right';
    default:
      return 'material-symbols:keyboard-arrow-left';
  }
};

function ArrowButton({ variant, sx, onClick, disabled }) {
  return (
    <IconButton
      sx={{
        width: '24px',
        height: '24px',
        borderRadius: '100px',
        border: '1px solid var(--grey-200, #DFE2E6)',
        background: '#FAFAFA',
        padding: 0,
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        ...sx,
      }}
      onClick={onClick}
      disabled={disabled}
    >
      <Iconify width={20} height={20} icon={getIconVariant(variant)} />
    </IconButton>
  );
}

ArrowButton.propTypes = {
  variant: PropTypes.oneOf(['right', 'left']),
  sx: PropTypes.any,
  onClick: PropTypes.func,
  disabled: PropTypes.bool,
};

ArrowButton.defaultProps = {
  variant: 'left',
  sx: {},
  onClick: () => {},
  disabled: false,
};

export default ArrowButton;
